import * as dataReducer from './Data'
import * as globalReducer from './Global'
import * as handoversReducer from './Handovers'
import * as todosReducer from './Todos'
import * as modalsReducer from './Modals'
import * as formsReducer from './Forms'
import * as carePlansReducer from './CarePlans'
import * as logsReducer from './Logs'

export default Object.assign(
  {},
  dataReducer,
  globalReducer,
  handoversReducer,
  todosReducer,
  modalsReducer,
  formsReducer,
  carePlansReducer,
  logsReducer
)
